import { initializeCompletionStatus } from './academy/_completion-status'
import { initializeTrainingFilter } from './academy/_training-filter'

initializeCompletionStatus()
initializeTrainingFilter()
